import React, { useEffect } from 'react';
import { useUIStore } from '../../../../stores';
import { Modal } from './Modal';
import { UnderDevelopmentModal } from './UnderDevelopmentModal';
import { ChangePasswordModal } from '../../../../features/account/components/ChangePasswordModal';
import { ChangeEmailModal } from '../../../../features/account/components/ChangeEmailModal';
import { ConfirmationModal } from './ConfirmationModal';
import { PremiumModal } from './PremiumModal';
import { ExportAttendanceModal } from './ExportAttendanceModal';
import { SystemLogsExportModal } from './SystemLogsExportModal';
import EditEmployeeModal from '../../../../features/employees/components/EditEmployeeModal';
import AssignWorkScheduleModal from '../../../../features/system/components/workSchedules/AssignWorkScheduleModal';
import ViewWorkScheduleAssignmentsModal from '../../../../features/system/components/workSchedules/ViewWorkScheduleAssignmentsModal';
import ImportEmployeesModal from '../../../../features/system/components/registrations/ImportEmployeesModal';
import DateRangeModal from './DateRangeModal';

// Register modal content components by type
const modalRegistry = {
  underDevelopment: UnderDevelopmentModal,
  changePassword: ChangePasswordModal,
  changeEmail: ChangeEmailModal,
  confirmation: ConfirmationModal,
  premium: PremiumModal,
  exportAttendance: ExportAttendanceModal,
  systemLogsExport: SystemLogsExportModal,
  editEmployee: EditEmployeeModal,
  assignWorkSchedule: AssignWorkScheduleModal,
  viewWorkScheduleAssignments: ViewWorkScheduleAssignmentsModal,
  importEmployees: ImportEmployeesModal,
  dateRange: DateRangeModal,
};

export const ModalHost = () => {
  const { modals, closeModal } = useUIStore();
  if (!modals.length) return null;

  // Auto-close all modals on route changes
  // Rationale: modals should not persist across pages unless explicitly desired
  // We rely on location.pathname which changes on navigation
  try {
    // Lazy import to avoid coupling in case react-router isn't present in some contexts
    // eslint-disable-next-line global-require
    const { useLocation } = require('react-router-dom');
    const location = useLocation();
    useEffect(() => {
      // Close any open modals on route change
      // We call store directly to avoid dependency on props
      const { closeAllModals } = useUIStore.getState();
      closeAllModals();
    }, [location.pathname]);
  } catch (e) {
    // noop if react-router not available
  }

  const sizeByType = { employeeDetail: 'md', editEmployee: 'md', exportAttendance: 'xl', assignWorkSchedule: 'xl', viewWorkScheduleAssignments: 'lg', importEmployees: 'lg', dateRange: 'md' };

  return (
    <>
      {modals
        .filter(m => m.isOpen)
        .map(modal => {
          const Content = modalRegistry[modal.type];
          if (!Content) return null;
          return (
            <Modal
              key={modal.id}
              isOpen={modal.isOpen}
              onClose={() => closeModal(modal.id)}
              size={modal.data?.size || sizeByType[modal.type] || 'sm'}
              showCloseButton={false}
            >
              <Content
                onClose={() => closeModal(modal.id)}
                featureName={modal.data?.featureName}
                data={modal.data}
              />
            </Modal>
          );
        })}
    </>
  );
};


